// The column template for a row of per-vertical cards: the dashboard's target cards and the delivery
// charts below them, over the same verticals in the same order, so each vertical's card sits directly
// above its chart. Two different minimums gave the two rows different column counts and nothing lined
// up.
export const VERTICAL_GRID = 'grid grid-cols-[repeat(auto-fit,minmax(20rem,1fr))] gap-4';
